import React from "react";

export default function WebsiteDesign() {
  return (
    <div className="page">
      <h1>Website Design & Maintenance</h1>
      <p>Website services placeholder.</p>
    </div>
  );
}
